import React from 'react';
import './ToggleSwitch.style.css'; // Import custom styles

interface ToggleSwitchProps {
  isOn: boolean;
  handleToggle: () => void;
  onLabel?: string;
  offLabel?: string;
  disabled?:boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  isOn,
  handleToggle,
  onLabel = 'ON ',
  offLabel = ' OFF',
  disabled = false
}) => {
  return (
    <div className={disabled ? "toggle-switch cursor-none" : "toggle-switch"}>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="toggle-switch-checkbox"
        id={`toggleSwitch`}
        type="checkbox"
        disabled = {disabled}
      />
      <label className="toggle-switch-label" htmlFor={`toggleSwitch`}>
        <span className="toggle-switch-inner" data-on={onLabel} data-off={offLabel} />
        <span className="toggle-switch-switch" />
      </label>
    </div>
  );
};

export default ToggleSwitch;